import { ref } from 'vue'

// Ref: https://codepen.io/Lucas-Dombrowski/pen/wvRoWzL

export const useTypewriter = () => {
    const placeholderEl = ref<HTMLDivElement>()
    const index = ref(0) // Initialize the index at the first element of the previously created array.
    const words = ref<string[]>([]) // Store all of the sentences pieces in an array.
    const typeInterval = ref(75)
    const eraseInterval = ref(25)
    const fullTextPauseInterval = ref(2000)
    const pauseBeforeStartInterval = ref(100)

    const writingTimeout = ref()
    const deletingTimeout = ref()

    const type = (word: string) => {
        if (!placeholderEl.value) return

        let i = 0

        //Set the interval that makes the writing animation.
        writingTimeout.value = setInterval(() => {
            //Add the letter at the i index of the current word in the placeholder.
            placeholderEl.value!.innerHTML += word.charAt(i)
            i++

            //If the i index reaches the end of the current word, the writing animation interval stops and the deleting animation beggins after a defined time.
            if (i >= word.length) {
                clearInterval(writingTimeout.value)
                setTimeout(erase, fullTextPauseInterval.value)
            }
        }, typeInterval.value)
    }

    const erase = () => {
        if (!placeholderEl.value) return

        //Set the interval that makes the deleting animation.
        deletingTimeout.value = setInterval(() => {
            //Pop off the last character of the previously written sentence.
            placeholderEl.value!.innerHTML = placeholderEl.value!.innerHTML.slice(0, -1)

            //If no one single letter remains, the deleting animation interval stops.
            if (placeholderEl.value!.innerHTML.length <= 0) {
                clearInterval(deletingTimeout.value)
                //The index var increases by 1, the writing animation is about to start with the next sentence.

                index.value++
                //If the index var reaches the end of the sentences array, set his value at 0 to looping from the first sentence of the array.
                if (index.value >= words.value.length) {
                    index.value = 0
                }

                setTimeout(() => {
                    type(words.value[index.value])
                }, pauseBeforeStartInterval.value)
            }
        }, eraseInterval.value)
    }

    const start = () => {
        if (!words.value || !words.value[index.value]) return
        type(words.value[index.value])
    }

    const pause = () => {
        clearInterval(writingTimeout.value)
        clearInterval(deletingTimeout.value)
    }

    return {
        placeholderEl,
        index,
        words,
        type,
        typeInterval,
        fullTextPauseInterval,
        pauseBeforeStartInterval,
        erase,
        eraseInterval,
        start,
        pause,
    }
}
